import React from 'react';
import { Card, Tooltip, Statistic } from 'antd';
import { 
  ThunderboltOutlined, 
  DollarOutlined, 
  DatabaseOutlined,
  InfoCircleOutlined 
} from '@ant-design/icons';

const TokenUsageIndicator = ({ tokenInfo, className = "" }) => {
  if (!tokenInfo) return null;

  const { promptTokens, completionTokens, totalTokens, costs, modelName, modelServer } = tokenInfo;

  return (
    <Card 
      className={`token-usage-indicator ${className}`}
      size="small"
      style={{
        background: 'linear-gradient(135deg, #d8ae5f 0%, #464646 100%)',
        border: 'none',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        color: 'white'
      }}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <DatabaseOutlined className="text-white opacity-80" />
            <span className="text-sm font-medium">Tokens</span>
          </div>
          
          <div className="flex items-center space-x-3 text-xs">
            <div className="flex items-center space-x-1">
              <span className="text-white opacity-80">Prompt:</span>
              <span className="font-semibold">{promptTokens.toLocaleString()}</span>
            </div>
            
            <div className="flex items-center space-x-1">
              <span className="text-white opacity-80">Completion:</span>
              <span className="font-semibold">{completionTokens.toLocaleString()}</span>
            </div>
            
            <div className="flex items-center space-x-1">
              <span className="text-white opacity-80">Total:</span>
              <span className="font-semibold">{totalTokens.toLocaleString()}</span>
            </div>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-1">
            <DollarOutlined className="text-white opacity-80" />
            <span className="text-sm font-semibold">
              ${costs.toFixed(6)}
            </span>
          </div>

          <Tooltip 
            title={`Model: ${modelName} | Server: ${modelServer}`}
            placement="top"
          >
            <InfoCircleOutlined className="text-white opacity-60 hover:opacity-100 cursor-help" />
          </Tooltip>
        </div>
      </div>
    </Card>
  );
};

export default TokenUsageIndicator;
